import { _firestore } from '@/lib/db';

export const GetRecentReports = ( uid, cb = null ) => {

	const recentReportsRef =  _firestore.collection( 'users' )
		.doc( uid )
		.collection( 'recentReports' )
		.orderBy( 'createdAt', 'desc' );


	const getReports = ( querySnapshot ) => {
		const reports = [];

		querySnapshot.forEach( ( doc ) => {
			reports.push( {
				id : doc.id,
				...doc.data()
			} );
		} );

		return reports;

	};

	if ( !cb ) {
		return recentReportsRef
			.get()
			.then( getReports );
	}

	return recentReportsRef
		.onSnapshot( ( querySnapshot ) => {
			const reports = getReports( querySnapshot );
			cb( reports );
		} );

};

export const AddRecentReport = async ( uid, data ) => {
	// Peel off uncessary data for new report
	const { id, createdAt, ...report } = data;

	const limit           = 6;
	const reports         = await GetRecentReports( uid );

	const duplicateReport = reports.find( r => r.text === report.text );

	const recentReportsRef = _firestore.collection( 'users' )
		.doc( uid )
		.collection( 'recentReports' );

	const batch = _firestore.batch();

	batch.set( recentReportsRef.doc(), {
		createdAt : new Date(),
		...report
	} );

	if ( duplicateReport ) { // Remove already existing report in firestore
		batch.delete( recentReportsRef.doc( duplicateReport.id ) );
	}
	else if ( reports.length >= limit ) { // Remove oldest report
		const oldestReport = reports[reports.length - 1];
		batch.delete( recentReportsRef.doc( oldestReport.id ) );
	}

	batch.commit();


};
